import React from 'react';
import NotificationItem from './NotificationItem';
import { Section as NotificationsSection } from '../../app/consumer/header/notifications_new.view';

interface SectionProps {
  section: NotificationsSection;
  correlationId: string;
}
export const Section = ({ section, correlationId }: SectionProps) => {
  const { title, alerts, backgroundColor } = section;

  const background = {
    backgroundColor: backgroundColor,
  };
  return (
    <div>
      <div className="cw_notif_section" style={backgroundColor ? background : null}>
        {title}
      </div>
      <ol className="cw_notif_list">
        {alerts.map((alert, i) => (
          <NotificationItem key={i} sectionTitle={section.title} notification={alert} correlationId={correlationId} />
        ))}
      </ol>
    </div>
  );
};
